import * as types from './mutation-type'

export default {
  setUserAndState({ commit }, user) {
    commit(types.SET_USER, user)
    commit(types.SET_LOGGED_IN, true)
    // 保存用户类型
    if (user.user_type) {
      commit(types.SET_USER_TYPE, user.user_type)
    }
  },

  loginOut({ commit }) {
    localStorage.clear()
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('blockchain_key_verified')
    }
    commit(types.REMOVE_LOGGED_IN, false)
  },

  readMessage({ commit }, message) {
    commit(types.REMOVE_UNREAD_MESSAGE, message.id)
    commit(types.MARK_READ_MESSAGE, message)
  },
}
